import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { chip } from './chip.vanilla.mjs';
import { ChipClearButton } from './components/clear-button/ClearButton.mjs';
import { ChipContent } from './components/content/Content.mjs';
import { ChipLabel } from './components/label/Label.mjs';
import { ChipValue } from './components/value/Value.mjs';
import { ChipContextProvider } from './context.mjs';

const ChipImpl = forwardRef(
  ({
    children,
    className: classNameFromProps,
    rightSlot,
    size,
    state,
    ...props
  }, forwardedRef) => {
    const className = classNames(chip({ size, state }), classNameFromProps);
    return /* @__PURE__ */ jsx(ChipContextProvider, { size, state, children: /* @__PURE__ */ jsxs(
      StyledDiv,
      {
        "data-scope": "chip",
        "data-part": "root",
        className,
        ref: forwardedRef,
        ...props,
        children: [
          children,
          rightSlot
        ]
      }
    ) });
  }
);
const StyledDiv = styled(Primitive.div);
ChipImpl.displayName = "Chip";
const Chip = Object.assign({}, ChipImpl, {
  Content: ChipContent,
  Label: ChipLabel,
  Value: ChipValue,
  ClearButton: ChipClearButton
});

export { Chip };
//# sourceMappingURL=Chip.mjs.map
